class FAQCollapsible extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = this.querySelector(".collapsible-content__header");
    const content = this.querySelector(".collapsible-content__grid");

    if (header && content) {
      // Hide content by default
      content.style.display = "none";

      header.addEventListener("click", () => {
        const isVisible = content.style.display === "flex";
        content.style.display = isVisible ? "none" : "flex";
      });
    }
  }
}

// Register it
customElements.define("faq-collapsible", FAQCollapsible);
